import { api, datesToISO } from "@";

// Function to get financial report based on search criteria
export const getFinancialReport = (search) =>
  api.post(`/api/AdminOrder/orders/financial-report`, {
    fromTime: datesToISO(search.fromDate) || null,
    toTime: datesToISO(search.toDate) || null,
  });
